import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

import Popin from './popin-view'

const popinContainer = document.getElementById('popin-root');

const Modal = ({children}) =>
  ReactDOM.createPortal(children, popinContainer)

class PopinContainer extends Component {
  state = {
    isInitialized: false
  }

  handleContentClick = e => {
    e.stopPropagation()
  }

  componentDidMount() {
    setTimeout(() => {this.setState({ isInitialized: true })}, 0);
    if (this.props.isOpened) {
      setTimeout(this.props.open, 0)
    }
  }

  render() {
    const viewProps = {
      isOpened: this.props.isOpened,
      isInitialized: this.state.isInitialized,
      handleLayerClick: this.props.close,
      handleContentClick: this.handleContentClick,
      title: this.props.title,
    }

    return (
      <Modal>
        <Popin {...viewProps}>
          {this.props.children}
        </Popin>
      </Modal>
    )
  }

}

PopinContainer.propTypes = {
  isOpened: PropTypes.bool.isRequired,
  title: PropTypes.string,
  open: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
}

export default PopinContainer
